<template>
    <div>
        <PlusButton @click="addTimeslot" :disabled="timeslots.length >= 10" />
        <AppWell>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-6" v-auto-animate>
                <AppCard v-for="(timeslot, index) in timeslots">
                    <div>
                        <div class="flex justify-between items-center">
                            <div>{{ $tc('messages.days', 2) }}</div>
                            <div>
                                <button type="button" :title="$t('messages.remove')" @click="deleteTimeslot(index)">
                                    <IconTrash class="text-gray-400 pr-1" />
                                </button>
                            </div>
                        </div>
                        <div class="mt-1 flex gap-1 flex-wrap">
                            <label v-for="day in days" :key="day.value">
                                <BadgePill :color="timeslot.days.includes(day.value) ? 'indigo' : 'gray'">
                                    <input
                                        :id="`[${index}]days_${day.value}`"
                                        :name="`[${index}]days[]`"
                                        :value="day.value"
                                        v-model="timeslot.days"
                                        type="checkbox"
                                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded sr-only"
                                    />
                                    <span class="text-sm font-mono">{{ day.text }}</span>
                                </BadgePill>
                            </label>
                        </div>
                        <div>
                            <FormError :value="errors[`timeslots.${index}.days`]" class="mt-2" />
                        </div>
                        <div class="flex gap-2">
                            <div class="">
                                <div class="mt-1">
                                    <FormLabel :value="$t('messages.time_from')" for="time_from" />
                                    <FormInput
                                        required
                                        :id="`[${index}]time_from`"
                                        v-model="timeslot.time_from"
                                        type="time"
                                        :name="`[${index}]time_from`"
                                        class="mt-1"
                                    />
                                    <FormError :value="errors[`timeslots.${index}.time_from`]" class="mt-2" />
                                </div>
                            </div>
                            <div class="">
                                <div class="mt-1">
                                    <FormLabel :value="$t('messages.time_to')" for="time_to" />
                                    <FormInput
                                        required
                                        :id="`[${index}]time_to`"
                                        v-model="timeslot.time_to"
                                        type="time"
                                        :name="`[${index}]time_to`"
                                        class="mt-1"
                                    />
                                    <FormError :value="errors[`timeslots.${index}.time_to`]" class="mt-2" />
                                </div>
                            </div>
                        </div>
                        <div>
                            <FormError :value="errors[`timeslots.${index}`]" class="mt-2" />
                        </div>
                    </div>
                </AppCard>
            </div>
        </AppWell>
    </div>
</template>
<script setup>
import AppCard from '@/Shared/AppCard.vue';
import AppWell from '@/Shared/AppWell.vue';
import BadgePill from '@/components/BadgePill.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import PlusButton from '@/components/Forms/PlusButton.vue';
import { IconTrash } from '@tabler/icons-vue';
import { useVModel } from '@vueuse/core';

let emit = defineEmits(['update:modelValue']);

const props = defineProps({
    modelValue: Object,
    days: Object,
    errors: Object,
});

const timeslots = useVModel(props, 'modelValue', emit);
const addTimeslot = () => {
    timeslots.value.push({
        days: [],
        time_from: '',
        time_to: '',
    });
};
const deleteTimeslot = (index) => {
    timeslots.value.splice(index, 1);
};
</script>
